"use client";

import Image from "next/image";
import Link from "next/link";

export function Partners() {
  const pastersList = [
    { src: "/assets/images/partners/01.svg", href: "https://skhappiness.org/" },
    { src: "/assets/images/partners/02.svg", href: "https://nanum.cu.co.kr/" },
    {
      src: "/assets/images/partners/03.svg",
      href: "https://www.daejeon.go.kr/",
    },
    {
      src: "/assets/images/partners/04.svg",
      href: "https://www.facebook.com/todag0419",
    },
    {
      src: "/assets/images/partners/05.svg",
      href: "https://www.dj-gonggam.com/",
    },
    {
      src: "/assets/images/partners/06.svg",
      href: "https://www.instagram.com/travel_school_gowalk/",
    },
    {
      src: "/assets/images/partners/07.svg",
      href: "https://www.soopooro.com/",
    },
    {
      src: "/assets/images/partners/08.svg",
      href: "https://www.fairtravelkorea.com/",
    },
    {
      src: "/assets/images/partners/09.svg",
      href: "https://www.hbpay.kr/app/main/index",
    },
    { src: "/assets/images/partners/10.svg", href: "https://wingwing.net/" },
    { src: "/assets/images/partners/11.svg", href: "https://value-plus.kr/" },
    { src: "/assets/images/partners/12.svg", href: "https://www.dicia.or.kr/" },
    {
      src: "/assets/images/partners/13.svg",
      href: "https://seicoop.kr/app/main/index",
    },
    {
      src: "/assets/images/partners/14.svg",
      href: "http://sesang-mansa.kr/app/main/index",
    },
    {
      src: "/assets/images/partners/15.svg",
      href: "https://www.semas.or.kr/web/main/index.kmdc",
    },
  ];
  return (
    <div className="bg-[#f2f3f5] py-20 md:py-40 px-5 xl:px-0 mt-30 pb-40">
      <div className="w-full xl:max-w-[1280px] xl:px-0 mx-auto flex justify-between lg:flex-row flex-col">
        <div className="lg:mr-20 mr-0 md:text-left text-center">
          <p
            className="md:text-2xl text-[15px] text-lightGray-20 mb-2 md:mb-6 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            United by our mission
          </p>
          <p
            className="md:text-5xl text-xl text-black-almostBlack tracking-tight md:leading-18  leading-8"
            style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
          >
            파트너
          </p>
        </div>

        <ul
          className="
          grow
    grid 
    grid-cols-2      
    md:grid-cols-3       
    lg:grid-cols-4           
    gap-5    
    lg:mt-0  
    mt-10
  "
        >
          {pastersList.map((paster, index) => (
            <li
              key={index}
              className="
              list-none bg-white flex justify-center items-center 
              rounded-3xl md:rounded-xl  w-full
              transition-transform duration-300 ease-out 
              hover:-translate-y-2 hover:shadow-md
              h-20 lg:h-36
              px-8 py-5 lg:px-4 lg:py-2 aspect-[4/3]
             
            "
            >
              <div className="relative w-full h-full flex items-center justify-center">
                <div className="relative w-[90%] md:w-[80%] h-[60%] flex items-center justify-center">
                  <Link href={paster.href} target="_blank">
                    <Image
                      src={paster.src}
                      alt={`paster-${index}`}
                      fill
                      className="object-contain grayscale opacity-70"
                    />
                  </Link>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
